import { Controller } from "@hotwired/stimulus"

// Horizontal tab strip that hints at overflow and survives page changes.
// Fades appear on whichever edge has more tabs hidden behind it, and the
// scroll position is carried across Turbo visits so tapping a tab that was
// scrolled into view doesn't snap the strip back to the start.
export default class extends Controller {
  static targets = ["scroller", "fadeStart", "fadeEnd"]
  static values = { key: String }

  connect() {
    this.restore()
    this.revealActive()
    this.update()
    this.resizeObserver = new ResizeObserver(() => this.update())
    this.resizeObserver.observe(this.scrollerTarget)
  }

  disconnect() {
    this.resizeObserver?.disconnect()
  }

  update() {
    const { scrollLeft, scrollWidth, clientWidth } = this.scrollerTarget
    this.fadeStartTarget.hidden = scrollLeft <= 1
    this.fadeEndTarget.hidden = scrollLeft + clientWidth >= scrollWidth - 1
  }

  save() {
    try {
      sessionStorage.setItem(this.storageKey, this.scrollerTarget.scrollLeft)
    } catch {}
  }

  restore() {
    let saved
    try {
      saved = sessionStorage.getItem(this.storageKey)
    } catch {}
    if (saved) this.scrollerTarget.scrollLeft = Number(saved)
  }

  // Covers fresh loads (e.g. a bookmarked ?status=adopted) where nothing was saved.
  revealActive() {
    const active = this.scrollerTarget.querySelector("[aria-current=page]")
    if (!active) return

    const strip = this.scrollerTarget.getBoundingClientRect()
    const tab = active.getBoundingClientRect()
    if (tab.left < strip.left || tab.right > strip.right) {
      this.scrollerTarget.scrollLeft += tab.left - strip.left - (strip.width - tab.width) / 2
    }
  }

  get storageKey() {
    return `tab-scroller:${this.keyValue}`
  }
}
